import { useState, useEffect, useRef, useCallback } from 'react';
import { fetchSensorData } from '../services/sensorService';

export const useSampleData = () => {
  const [sampleData, setSampleData] = useState([]);
  const [csvExportData, setCsvExportData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [machine, setMachine] = useState('');
  const [loading, setLoading] = useState(false);
  const csvLinkRef = useRef();

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchSensorData(startDate, endDate, '', machine, '/data-5s');
      setSampleData(data);
    } catch (err) {
      console.error("샘플 데이터 로드 실패:", err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, machine]);

  const exportFilteredData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchSensorData(startDate, endDate, '', machine, '/data-5s');
      const mapped = data.map(({ ...rest }) => ({
        ...rest,
        timestamp: rest.timestamp || rest.created_at
      }));
      setCsvExportData(mapped);
    } catch (err) {
      console.error("CSV 내보내기 실패:", err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, machine]);

  useEffect(() => {
    if (csvExportData.length > 0 && csvLinkRef.current) {
      csvLinkRef.current.link.click();
    }
  }, [csvExportData]);

  return {
    sampleData,
    csvExportData,
    startDate,
    endDate,
    machine,
    loading,
    setStartDate,
    setEndDate,
    setMachine,
    loadData,
    exportFilteredData,
    csvLinkRef
  };
};